import { PropsWithChildren } from 'react';

import { Icon } from 'common';

import {
  Container,
  LeftContainer,
  FormContainer,
  RightContainer,
} from './styles';

export const AuthLayout = ({ children }: PropsWithChildren<unknown>) => {
  return (
    <Container>
      <LeftContainer>
        <Icon icon="logo" />
        <Icon icon="sub-logo" />
      </LeftContainer>

      <RightContainer>
        <FormContainer>{children}</FormContainer>
      </RightContainer>
    </Container>
  );
};
